import React from 'react';
import productsData from '../../data/productsData.json';

function RecommendationList({ recommendations }) {
  const getProductLink = (productName) => {
    return productsData[productName]?.link || '#';
  };

  const getProductDetails = (productName) => {
    return productsData[productName] || { description: '', benefits: [] };
  };

  return (
    <div>
      <div className="bg-gradient-to-br from-rd-navy to-blue-900 p-4 md:p-6 rounded-xl text-white">
        <h2 className="text-xl md:text-2xl font-bold mb-4 flex items-center">
          <span className="text-2xl md:text-3xl mr-2">🎯</span>
          Recomendações
        </h2>

        {recommendations.length === 0 ? (
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg text-center">
            <p className="text-rd-cyan text-lg mb-2">✨ Aguardando seleção</p>
            <p className="text-white/70 text-sm">
              Selecione suas preferências e funcionalidades para receber
              recomendações personalizadas
            </p>
          </div>
        ) : (
          <div className="flex flex-wrap justify-center gap-4">
            {recommendations.map((recommendation, index) => (
              <div
                key={index}
                className="bg-white text-rd-navy p-3 md:p-4 rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl w-full lg:w-[calc(33.333%-1rem)] lg:max-w-xs animate-slide-up opacity-0 flex flex-col"
                style={{
                  animationDelay: `${index * 150}ms`,
                  animationFillMode: 'forwards',
                }}
              >
                <div className="flex items-start p-2 flex-1 flex-col">
                  <div className="flex-1 w-full">
                    <h3 className="font-bold text-lg mb-1">
                      {recommendation.name}
                    </h3>
                    <span className="inline-block bg-rd-blue text-white text-xs px-3 py-1 rounded-full">
                      {recommendation.category}
                    </span>

                    <p className="mt-3 text-sm text-gray-600 leading-relaxed">
                      {getProductDetails(recommendation.name).description}
                    </p>

                    <ul className="mt-3 space-y-1.5">
                      {getProductDetails(recommendation.name).benefits.map(
                        (benefit, idx) => (
                          <li
                            key={idx}
                            className="text-sm text-gray-700 flex items-start"
                          >
                            <span className="text-rd-cyan mr-2 mt-0.5">✓</span>
                            <span>{benefit}</span>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                  {recommendation.score && (
                    <div className="mt-4 w-full">
                      <div className="flex items-center justify-between text-sm text-gray-600 mb-1">
                        <span>Compatibilidade</span>
                        <span className="font-bold text-rd-navy">
                          {recommendation.score === 1
                            ? `${recommendation.score} ponto`
                            : `${recommendation.score} pontos`}
                        </span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div
                          className="bg-gradient-to-r from-rd-blue to-rd-cyan h-2 rounded-full transition-all duration-500"
                          style={{
                            width: `${(recommendation.score / 6) * 100}%`,
                          }}
                        ></div>
                      </div>
                    </div>
                  )}

                  <a
                    href={getProductLink(recommendation.name)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 block w-full bg-white border border-rd-navy text-rd-navy font-normal py-2 px-4 rounded-md text-center hover:bg-rd-navy hover:text-white transition-all duration-300"
                  >
                    Conhecer planos →
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default RecommendationList;
